import React from 'react';
import { useTranslation } from 'react-i18next';
import { RgbaColor } from '@uiw/color-convert';
import { LightSlider, SubmitButton } from '../../../components';
import RgbPicker from '../../../components/channel-details-controls/light/picker';

type RgbwChannelSettingsProps = {
  rgbValue: string;
  handleColorPicked: (rgba: RgbaColor) => void;
  handleSubmit: () => void;
  wValue?: number;
  brightness?: number;
  handleChangeW?: (val: number) => void;
  handleWValue?: (val: number) => void;
  handleBrightness?: (val: number) => void;
  handleChangeBrightness?: (val: number) => void;
};

export const RgbwChannelSettings: React.FC<RgbwChannelSettingsProps> = ({
  rgbValue,
  wValue,
  brightness,
  handleWValue,
  handleChangeW,
  handleColorPicked,
  handleSubmit,
  handleBrightness,
  handleChangeBrightness,
}) => {
  const { t } = useTranslation('action');

  return (
    <>
      <RgbPicker
        rgbValue={rgbValue}
        handleColorPicked={handleColorPicked}
        handleBrightness={handleBrightness}
        handleChange={handleChangeBrightness}
        brightness={brightness}
        brightnessLabel={t('action.create.tasks.states.brightnessColor')}
      />
      {handleWValue && handleChangeW && wValue !== undefined && (
        <div className="details-page__controls-slider p-l-24 p-r-24">
          <LightSlider
            value={wValue}
            onChange={handleChangeW}
            onPointerUp={handleWValue}
            label={t('action.create.tasks.states.wLed')}
          />
        </div>
      )}
      <SubmitButton onClick={handleSubmit} />
    </>
  );
};
